module.exports = __webpack_public_path__ + "img/insta.35cd7416.svg";